export default "__VITE_ASSET__k8EulSxk__"